import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import { 
  FormControlLabel, OutlinedInput, Select, Switch, MenuItem,
  Input, InputLabel, Box, FormControl, FormHelperText, TextField, 
  CssBaseline, Grid, Typography, Container } 
from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  warningNote: {
    color: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  }
}));

const AddEvent = (props) => {

  const [formTitleIn, setFormTitleIn] = React.useState('')
  const [formStartIn, setFormStartIn] = React.useState(`${props.dateClickData}T12:30`)
  const [formEndIn, setFormEndIn] = React.useState(`${props.dateClickData}T13:00`)
  const [formOrgIn, setFormOrgIn] = React.useState(props.currentOrg)
  const [recurringEvent, setRecurringEvent] = React.useState(false)
  const [rruleFrequency, setrruleFrequency] = React.useState('')
  const [rruleInterval, setrruleInterval] = React.useState(1)
  const [rruleByweekday, setrruleByweekday] = React.useState([])
  const [rruleBymonth, setrruleBymonth] = React.useState([])
  const [rruleDtstart, setrruleDtstart] = React.useState(`${props.dateClickData}T12:30`)
  const [rruleUntil, setrruleUntil] = React.useState('')
  const [fieldError, setFieldError] = React.useState(false)

  const classes = useStyles();
  
  const formValidation = (event) => {
    event.preventDefault()
    
    // parse rrule data for server - rrule needs null values for unused fields 
    let formRRuleIn = {}
    if (recurringEvent){
      formRRuleIn = {
        freq: rruleFrequency,
        interval: parseInt(rruleInterval),
        byweekday: rruleByweekday.length === 0 ? null : rruleByweekday,
        bymonth: rruleBymonth.length === 0 ? null : rruleBymonth,
        dtstart: rruleDtstart,
        until: rruleUntil ? rruleUntil : null
      }
    } else {
      formRRuleIn = null
    }
    
    let formData = { 
      formTitle: formTitleIn,
      formStart: !recurringEvent ? formStartIn : '',
      formEnd: !recurringEvent ? formEndIn : '',
      formOrg: formOrgIn,
      formRRule: formRRuleIn
    }

    if (!recurringEvent) {
      if (!formData.formTitle || !formData.formStart || !formData.formEnd || !formData.formOrg) {
        setFieldError(true)
      } else {
        handleSubmit(formData)
        props.setDatePopoverAnchorEl(null)
      } 
    } else {
      if (!formData.formTitle || !formData.formOrg || !formRRuleIn.freq || !formRRuleIn.dtstart || !formRRuleIn.interval) {
        setFieldError(true)
      } else {
        handleSubmit(formData)
        props.setDatePopoverAnchorEl(null)
      }
    }
  }

  const handleSubmit = async (formData) => {
    let url = 'https://api.event-calendar.oneilgordon.dev/addEvent'
    let res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    let resData = await res.json()
    props.setCalData(resData.events)
    props.setCurrentOrg(formData.formOrg)
    console.log('setCalData called in add event component')
    console.log(props.calData)
  }

  const handleSwitch = (event) => {
    setRecurringEvent(event.target.checked)
  }

  return (
    <Container maxWidth='xs'>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <AddIcon />
        </Avatar>
        <Typography component='h1' variant='h5'>
          Add Event
        </Typography>
        <form onSubmit={formValidation} className={classes.form} noValidate>
          <FormControlLabel
            control={<Switch
              checked={recurringEvent}
              onChange={handleSwitch}
              inputProps={{'aria-label':'controlled'}}
            />}
            label='Recurring Event'
          />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                  variant='outlined'
                  required
                  fullWidth
                  name='formTitleIn'
                  label='Event Title'
                  id='title'
                  onChange={event => setFormTitleIn(event.target.value)}
                />
            </Grid>
          </Grid>

            {/* Hide start and end date for recurring events */}
            {!recurringEvent ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={`${props.dateClickData}T12:30`}
                    name='formStartIn'
                    variant='outlined'
                    required
                    fullWidth
                    type='datetime-local'
                    id='start'
                    label='Start Time'
                    onChange={event => setFormStartIn(event.target.value)}
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant='outlined'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={`${props.dateClickData}T13:00`}
                    required
                    fullWidth
                    id='end'
                    type='datetime-local'
                    label='End Time'
                    name='formEndIn'
                    onChange={event => setFormEndIn(event.target.value)}
                  />
                </Grid>
              </Grid>
            ) : null}
            {/* end hiding for recurring events */}
            
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant='outlined'
                defaultValue={props.currentOrg}
                required
                fullWidth
                id='org'
                label='Organization Name'
                name='formOrgIn'
                onChange={event => setFormOrgIn(event.target.value)}
              />
            </Grid>
          </Grid>

            {/* recurring events form starts here*/} 
            {recurringEvent ? (
             <Grid container spacing={2}> 
              <Grid item xs={12}>
                Recurrence Settings
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant='outlined'>
                <InputLabel required>Frequency</InputLabel>
                <Select
                  value={rruleFrequency}
                  id='rrulefreq'
                  label='Frequency'
                  name='rrulefreq'
                  onChange={event => setrruleFrequency(event.target.value)}
                >
                  <MenuItem value={'yearly'}>Yearly</MenuItem>
                  <MenuItem value={'monthly'}>Monthly</MenuItem>
                  <MenuItem value={'weekly'}>Weekly</MenuItem>
                  <MenuItem value={'daily'}>Daily</MenuItem>
                </Select>
                <FormHelperText>How often to repeat event</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  InputProps={{
                    inputProps: {
                      min:1
                    }
                  }}
                  required
                  variant='outlined'
                  fullWidth
                  label='Interval'
                  helperText='Interval between each freq'
                  value={rruleInterval}
                  id='rruleinterval'
                  type='number'
                  name='rruleinterval'
                  onChange={event => setrruleInterval(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant='outlined'>
                <InputLabel>Weekdays</InputLabel>
                <Select
                  variant='outlined'
                  label='Weekdays'
                  fullWidth
                  multiple
                  value={rruleByweekday}
                  id='rrulebywekday'
                  name='rrulebyweekday'
                  onChange={event => setrruleByweekday(event.target.value)}
                >
                  <MenuItem value={'su'}>Sunday</MenuItem>
                  <MenuItem value={'mo'}>Monday</MenuItem>
                  <MenuItem value={'tu'}>Tuesday</MenuItem>
                  <MenuItem value={'we'}>Wednesday</MenuItem>
                  <MenuItem value={'th'}>Thursday</MenuItem>
                  <MenuItem value={'fr'}>Friday</MenuItem>
                  <MenuItem value={'sa'}>Saturday</MenuItem>
                </Select>
                <FormHelperText>Can select multiple</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant='outlined'>
                <InputLabel>Months</InputLabel>
                <Select
                  variant='outlined'
                  label='Months'
                  fullWidth
                  multiple
                  value={rruleBymonth}
                  id='rrulebymonth'
                  name='rrulebymonth'
                  onChange={event => setrruleBymonth(event.target.value)}
                >
                  <MenuItem value={1}>January</MenuItem>
                  <MenuItem value={2}>Febuary</MenuItem>
                  <MenuItem value={3}>March</MenuItem>
                  <MenuItem value={4}>April</MenuItem>
                  <MenuItem value={5}>May</MenuItem>
                  <MenuItem value={6}>June</MenuItem>
                  <MenuItem value={7}>July</MenuItem>
                  <MenuItem value={8}>August</MenuItem>
                  <MenuItem value={9}>September</MenuItem>
                  <MenuItem value={10}>October</MenuItem>
                  <MenuItem value={11}>November</MenuItem>
                  <MenuItem value={12}>Devember</MenuItem>
                </Select>
                <FormHelperText>Can select multiple</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  defaultValue={`${props.dateClickData}T12:30`}
                  variant='outlined'
                  fullWidth
                  type='datetime-local'
                  id='rruledtstart'
                  label='Start Date'
                  name='rruledtstart'
                  onChange={event => setrruleDtstart(event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant='outlined'
                  fullWidth
                  type='datetime-local'
                  id='rruleuntil'
                  label='Until'
                  name='rruleuntil'
                  onChange={event => setrruleUntil(event.target.value)}
                />
              </Grid>
            </Grid>  
            ) : null}
             {/*end of recurring events form*/}
            

            {fieldError ? 
              <Grid 
                item xs={12} 
                className={classes.warningNote}
              >
              Please complete all fields marked with a (*) 
            </Grid>: null}

          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
          >
            Add Event
          </Button>
        </form>
      </div>
    </Container>
  );
}

export default AddEvent